import { RequestKind, boolean, string } from '@sb/library/base';
import { AttendanceAttachmentFileInputItem, DisplayItemCollection, LibraryOnlineDisplayItem, LibraryOnlineLogDisplayItem, LibraryOnlineLogSearchOptions, OnlineResourceFileInputItem, OnlineResourceFolderInputItem, OnlineResourceSpaceDisplayItem, OnlineResourceUpdateItem, OnlineResourcesAccessUpdateItem, OnlineResourcesMoveUpdateItem, OnlineResourcesSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace OnlineResourcesRoutes {
    export const Get = ApiRoute.Define({
        URL: (itemID: string) => `onlineresources/${itemID}`,
        Kind: RequestKind.Get,
        ResultType: LibraryOnlineDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: 'onlineresources',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<LibraryOnlineDisplayItem>,
        PagingAllowed: true
    });

    export const Search = ApiRoute.Define({
        URL: 'search/onlineresources',
        Kind: RequestKind.Post,
        BodyType: OnlineResourcesSearchOptions,
        ResultType: DisplayItemCollection<LibraryOnlineDisplayItem>,
        PagingAllowed: true
    });

    export const GetLogs = ApiRoute.Define({
        URL: (itemID: string) => `onlineresources/${itemID}/logs`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<LibraryOnlineLogDisplayItem>
    });

    export const SearchLogs = ApiRoute.Define({
        URL: `search/onlineresources/logs`,
        Kind: RequestKind.Post,
        BodyType: LibraryOnlineLogSearchOptions,
        ResultType: DisplayItemCollection<LibraryOnlineLogDisplayItem>
    });

    export const GetSpaces = ApiRoute.Define({
        URL: 'onlineresources/spaces',
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<OnlineResourceSpaceDisplayItem>
    });

    export const CreateFolder = ApiRoute.Define({
        URL: 'onlineresources/folders',
        Kind: RequestKind.Post,
        BodyType: OnlineResourceFolderInputItem,
        ResultType: string
    });

    export const CreateFile = ApiRoute.Define({
        URL: 'onlineresources',
        Kind: RequestKind.Post,
        BodyType: OnlineResourceFileInputItem,
        ResultType: string
    });

    export const SetAccess = ApiRoute.Define({
        URL: 'onlineresources/permissions',
        Kind: RequestKind.Patch,
        BodyType: OnlineResourcesAccessUpdateItem,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (itemID: string) => `onlineresources/${itemID}`,
        Kind: RequestKind.Put,
        BodyType: OnlineResourceUpdateItem,
        ResultType: boolean
    });

    export const Move = ApiRoute.Define({
        URL: 'onlineresources',
        Kind: RequestKind.Patch,
        BodyType: OnlineResourcesMoveUpdateItem,
        ResultType: boolean
    });

    export const Delete = ApiRoute.Define({
        URL: (itemID: string) => `onlineresources/${itemID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });
}
